import { getById } from "@insite/client-framework/Store/Data/DataState";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import { createContext } from "react";
// import { createContext } from "vm";

export function getExpediteShippingOrderHistoryStateById(state: ApplicationStateTKCCP,OrderHistoryId: string) {
    return getById(state.expediteShippingOrderHistory, OrderHistoryId);
}


export const ExpediteOrderContext = createContext<ReturnType<typeof getExpediteShippingOrderHistoryStateById>>({
    value: undefined,
    isLoading: false,
    errorStatusCode: undefined,
    id: undefined,
});
